module.exports = __webpack_public_path__ + "img/commit.ed2c9f82.svg";